import React from "react";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";

// The mobile app renders html_details with no Quill stylesheet, so alignment and
// direction MUST be emitted as inline styles (not Quill's ql-align-* classes).
// Register the style attributors once so getHTML() produces style="text-align:right".
const AlignStyle = Quill.import("attributors/style/align");
const DirectionStyle = Quill.import("attributors/style/direction");
Quill.register(AlignStyle, true);
Quill.register(DirectionStyle, true);

const MODULES = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ["bold", "italic", "underline"],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ align: [] }, { direction: "rtl" }],
    ["link", "clean"],
  ],
};

const FORMATS = [
  "header",
  "bold",
  "italic",
  "underline",
  "list",
  "bullet",
  "align",
  "direction",
  "link",
];

// `value` is plain HTML (already decoded). `onChange` receives plain HTML.
// Encoding to the app's htmlspecialchars storage format is the caller's job.
export default function RichTextEditor({ value, onChange, dir = "ltr" }) {
  return (
    <div className="oc-richtext" dir={dir}>
      <ReactQuill
        theme="snow"
        value={value ?? ""}
        onChange={onChange}
        modules={MODULES}
        formats={FORMATS}
      />
    </div>
  );
}
